import React, { useState } from 'react';
import { PlansStyle } from './formsStyle';
import LogoAmilFacil from '../../components/assets/logo_amilFacil.svg';
import AmilCima from '../../components/assets/amil_cima.svg';
import AmilBaixo from '../../components/assets/amil_baixo.svg';
import LogoBradesco from '../../components/assets/logo_bradesco.svg';
import BradescoCima from '../../components/assets/bradesco_cima.svg';
import BradescoBaixo from '../../components/assets/bradesco_baixo.svg';
import LogoNDI from '../../components/assets/logo_notredame.svg';
import NDICima from '../../components/assets/ndi_cima.svg';
import NDIBaixo from '../../components/assets/ndi_baixo.svg';
import { FormGroup, Input } from 'reactstrap';
import Footer from '../../components/footer/Footer';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormPlans = () => {
  React.useEffect(() => {
    // Quando o componente é montado, altera a cor de fundo do #root
    const root = document.getElementById('root');
    root.style.backgroundColor = '#FFFFFF';
    const timeoutId = setTimeout(() => {
      root.style.overflow = 'auto';
    }, 0); // Define para a cor desejada

    // Quando o componente é desmontado, restaura a cor original ou define para uma nova cor padrão
    return () => {
      root.style.backgroundColor = '#00022D'; // Cor original ou nova cor padrão
      root.style.overflow = 'hidden';
    };
  }, []);

  const [selectedPlans, setSelectedPlans] = useState([]);

  const handleSelectChange = (e) => {
    const plan = e.target.value;
    setSelectedPlans((prevSelectedPlans) => {
      if (!prevSelectedPlans.includes(plan)) {
        // Adiciona o novo plano e garante que não exceda três planos
        const updatedSelectedPlans = [...prevSelectedPlans, plan].slice(-3);
        return updatedSelectedPlans;
      }
      return prevSelectedPlans;
    });
  };

  const renderPlanDetails = () => {
    // Mapeia cada plano selecionado para seu componente JSX
    return selectedPlans.map((plan) => {
      let content;
      switch (plan) {
        case 'Amil':
          content = (
            <div className="plan-detail amilPlans">
              <img className="logo-img" src={LogoAmilFacil} alt="Amil Fácil" />
              <img className="parte-cima" src={AmilCima} alt="Amil - Cima" />
              <img className="parte-baixo" src={AmilBaixo} alt="Amil - Baixo" />
            </div>
          );
          break;
        case 'Bradesco':
          content = (
            <div className="plan-detail bradescoPlans">
              <img className="logo-img" src={LogoBradesco} alt="Bradesco" />
              <img
                className="parte-cima"
                src={BradescoCima}
                alt="Bradesco - Cima"
              />
              <img
                className="parte-baixo"
                src={BradescoBaixo}
                alt="Bradesco - Baixo"
              />
            </div>
          );
          break;
        case 'NDI':
          content = (
            <div className="plan-detail ndiPlans">
              <img
                className="logo-img"
                src={LogoNDI}
                alt="NotreDame Intermédica"
              />
              <img className="parte-cima" src={NDICima} alt="NDI - Cima" />
              <img className="parte-baixo" src={NDIBaixo} alt="NDI - Baixo" />
            </div>
          );
          break;
        default:
          content = null;
      }
      return content; // Retorna o conteúdo JSX para o plano atual
    });
  };

  return (
    <PlansStyle>
      <div className="plans__wrapper">
        <div className="container">
          <div className="title__wrapper">
            <h1 className="title">
              Confira as melhores opções de planos de saúde para você!
            </h1>

            <div className="stripe col-12 col-md-10">
              <p className="content">
                Se preferir, fale com um especialista e tire todas as suas
                dúvidas!
              </p>
              <a href="#" className="button">
                <p className="button_text">Quero falar com um especialista</p>
              </a>
            </div>
          </div>

          <FormGroup>
            <Input
              type="select"
              id="Operators"
              name="operator"
              onChange={handleSelectChange}
              value=""
            >
              <option value="">Selecione um plano</option>
              <option value="Amil">Amil Fácil</option>
              <option value="Bradesco">Bradesco</option>
              <option value="NDI">NotreDame Intermédica</option>
            </Input>
          </FormGroup>
          <div className="plans-container">{renderPlanDetails()}</div>
        </div>
      </div>
    </PlansStyle>
  );
};

export default FormPlans;
